// Basit SemVer karsilastirma (bagimlilik yok).
// "1.2.3", "1.2.3-beta.1" gibi degerleri isler; prerelease ekini yok sayar.

export function parseSemver(v) {
  if (!v) return [0, 0, 0];
  const core = String(v).trim().replace(/^v/, "").split("-")[0];
  const parts = core.split(".").map((n) => parseInt(n, 10) || 0);
  return [parts[0] || 0, parts[1] || 0, parts[2] || 0];
}

// a<b -> -1, a==b -> 0, a>b -> 1
export function compareSemver(a, b) {
  const pa = parseSemver(a);
  const pb = parseSemver(b);
  for (let i = 0; i < 3; i++) {
    if (pa[i] > pb[i]) return 1;
    if (pa[i] < pb[i]) return -1;
  }
  return 0;
}

/**
 * frontend surumu, backend'in bildirdigi aralikta mi?
 * range: { min, max } (max null olabilir = ust sinir yok)
 * Donen: "ok" | "too_old" | "too_new" | "unknown"
 */
export function checkFrontendCompatibility(frontendVersion, range) {
  if (!range || !range.min) return "unknown";
  if (compareSemver(frontendVersion, range.min) < 0) return "too_old";
  if (range.max && compareSemver(frontendVersion, range.max) > 0) return "too_new";
  return "ok";
}
